module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0010.fa008bff.jpg";